import m from "color-convert";
import d from "./getThemeDefinition.js";
function f(e, a, s, h, i) {
  let r = e + 50;
  r > 100 && (r = 100);
  const o = e * (1 - a) + a * r, [, n, t] = m.lab.hsl([
    o,
    s,
    h
  ]), [u, l, c] = m.hsl.lab([
    i,
    n,
    t
  ]);
  return Math.abs(o - u) > 10 ? f(e, a, l, c, i) : `#${m.hsl.hex([
    i,
    n,
    t
  ])}`;
}
function y(e, a) {
  const s = d(a), h = s.palette.mode === "light";
  if (e === s.primaryFill)
    return s;
  const [i, r, o] = m.hex.lab(e), n = m.hex.hsl(e)[0];
  let t = i;
  t > 80 && (t = 80), h || t < 40 && (t = 40);
  const u = i === t ? e : f(t, 0, r, o, n), l = f(t, 0.5, r, o, n), c = f(t, 0.25, r, o, n);
  return {
    ...s,
    primaryFill: u,
    primaryHover: l,
    primarySelected: c,
    primaryFocus: l
  };
}
export {
  y as default
};
